import React from 'react'
import Navbar from '../header/Navbar'
import Footer from '../footer/Footer'
import HeroImg2 from '../additional/HeroImg2'
import AboutContent from '../additional/AboutContent'

const About = () => {
  return (
    <div>
      <Navbar/>
      <HeroImg2 heading="ABOUT" text="I'm a friendly software Developer."/>
      <AboutContent/>
      <Footer/>
    </div>
  )
}

export default About